<div class="container-fluid">
  <h5>{{ 'feature.search.result' | translate }}:&nbsp;''{{searchText}}''</h5>
  <div style="min-height: 3rem">
    <button (click)="changeTab('song')" class="btn btn-info my-2">
      {{'common.entity.song' | translate}}&nbsp;<i class="bi bi-caret-right-fill"></i>
    </button>
    <table class="table table-striped table-responsive">
      <thead>
        <tr>
          <th scope="col" style="width: 10%">#</th>
          <th scope="col" style="width: 50%">{{ 'common.label.title' | translate }}</th>
          <th scope="col" style="width: 10%"></th>
          <th scope="col" style="width: 10%"></th>
          <th scope="col" style="width: 20%"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          [tabIndex]="song.id"
          [routerLink]="['/song','detail']"
          [queryParams]="{id: song.id}"
          *ngFor="let song of searchSummary.song.content | likes:'SONG': (currentUser$ | async) | slice:0:3; index as i"
        >
          <td style="width: 10%">{{ i + 1 }}</td>
          <td style="width: 50%">
            <a [routerLink]="['/song','detail']" [queryParams]="{id: song.id}"><h5>{{song.title}}</h5></a>
            <a *ngFor="let artist of song.artists; index as j"
              ><small>{{ artist.name }}{{ j === song.artists.length - 1 ? '' : ', '}}</small></a
            >
          </td>
          <td style="width: 10%">
            <small>{{ song.duration | duration }}</small>
          </td>
          <td style="width: 10%">
            <span class="float-right"
              ><small><i class="bi bi-headphones"></i> {{song.listeningFrequency}}</small></span
            >
          </td>
          <td style="width: 20%">
            <app-song-like-btn [song]="song"></app-song-like-btn>
            <app-song-menu-btn [song]="song"></app-song-menu-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div style="min-height: 3rem">
    <button (click)="changeTab('album')" class="btn btn-info mb-2">
      {{'common.entity.album' | translate}}&nbsp;<i class="bi bi-caret-right-fill"></i>
    </button>
    <div class="row row-cols-sm-auto gy-5 mb-2">
      <div
        *ngFor="let album of searchSummary.album.content | likes:'ALBUM': (currentUser$ | async) | slice:0:3; index as i"
        class="col-sm-4"
      >
        <app-card [type]="1" [tileHoverEffect]="true">
          <a cardHeader1 [routerLink]="['/album', 'detail']" [queryParams]="{id: album.id}">{{ album.title }}</a>
          <div cardText1 class="align-items-center h-100">
            <a [routerLink]="['/album', 'detail']" [queryParams]="{id: album.id}"
              ><img class="card-img img-thumbnail album-cover" [src]="album.coverUrl | mediaUrl" alt=""
            /></a>
          </div>
          <div cardFooter1 class="d-flex align-items-center justify-content-center">
            <button (click)="addAlbumToPlaying(album, $event)" class="btn btn-sm btn-info rounded-circle" [disabled]="album.isDisabled">
              <i class="bi bi-play"></i>
            </button>
            <app-album-like-btn [album]="album"></app-album-like-btn>
          </div>
        </app-card>
      </div>
    </div>
  </div>
  <div style="min-height: 3rem">
    <button (click)="changeTab('artist')" class="btn btn-info my-2">
      {{'common.entity.artist' | translate}}&nbsp;<i class="bi bi-caret-right-fill"></i>
    </button>
    <div class="row g-5">
      <div
        class="col-md-3"
        *ngFor="let artist of (searchSummary.artist.content | likes:'ARTIST': (currentUser$ | async)) | slice:0:3; index as i"
        [routerLink]="['/artist', 'detail']"
        [queryParams]="{id: artist.id}"
      >
        <div class="avatar-container">
          <img class="avatar" [src]="artist.avatarUrl | mediaUrl" alt="" />
          <div class="like-btn-container d-flex justify-content-center">
            <app-artist-like-btn [ngClass]="'mt-auto mb-2'" [artist]="artist"></app-artist-like-btn>
          </div>
          <div class="w-100 position-absolute bottom-0 d-flex justify-content-center align-items-center" style="height: 2rem">
            <span>{{ artist.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
